import React, {useMemo} from 'react';
import {connect} from "react-redux";

import {FormattedMessage} from "react-intl";
import {Button} from "@mui/material";
import ShuffleIcon from "@mui/icons-material/Shuffle";
import ConfirmButtons from "./ConfirmButtons";
import {FEATURE_PICKER_TYPE, SQFT_FEATURES} from "../../../../constants";
import {setFeaturePicker} from "../../../../../../actions/sqftMenuFunctions";
import workspaceControllers from "../../../canvas/store/workspaceControllers";
import FeatureName from "../../../../../visComponents/featureName";
import {getCurrentLayout} from "../../../../../appLayout";
import FeatureThumbnail from "../../../../../visComponents/featureThumbnail";

const Hinges = (props) => {
  const {featurePicker, setFeaturePicker, selectedFeatureInPicker, sqftActiveShapeId, resourceControllerCounter} = props;

  const changeHinge = () => {
    setFeaturePicker(
      {
        isOpen: true,
        modelId: null,
        partIds: [SQFT_FEATURES.hinge],
        shapeId: sqftActiveShapeId,
        type: FEATURE_PICKER_TYPE.hinges
      }
    )
  }

  const confirmCallback = () => {
    workspaceControllers.hinge.changeFeatureForTheShape(featurePicker.shapeId, selectedFeatureInPicker);

    setFeaturePicker({ isOpen: false, partIds: [], shapeId: '', type: '' });
  }

  const layout = getCurrentLayout();
  const lineHingesModel = useMemo(() => {
    return workspaceControllers.hinge.getAllResourcesForTheShape(sqftActiveShapeId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resourceControllerCounter]);

  if (!lineHingesModel.length) {
    return null
  }

  const feature = layout.getFeatureById(lineHingesModel[0].featureId, true);

  console.log("handleFeature", feature);
  return (
    <div className="sr__section sr__handles">
      <div className="sr__section-title">
        <FormattedMessage id="Current Hinge"/>
      </div>
      <div>
        <div className="sr__section-image">
          <FeatureThumbnail feature={feature} dbFeatureId={feature.dbFeature.id}/>
        </div>
        <label className="handles__label">
          <FeatureName feature={feature} />
        </label>
        {
          featurePicker.isOpen && featurePicker.type === FEATURE_PICKER_TYPE.hinges
            ? <ConfirmButtons confirmCallback={confirmCallback}/>
            : <Button
              className={"sr__button "}
              variant="outlined"
              color="primary"
              startIcon={<ShuffleIcon style={{ transform: 'rotate(180deg)' }}/>}
              onClick={() => changeHinge()}
            >
              <FormattedMessage id={"Swap Hinge"}/>
            </Button>
        }
      </div>
    </div>
  );
};

const mapStateToProps = (store) => ({
  sqftActiveShapeId: store.sqftMenuState.sqftActiveShapeId,
  featurePicker: store.sqftMenuState.featurePicker,
  selectedFeatureInPicker: store.sqftMenuState.selectedFeatureInPicker,
  resourceControllerCounter: store.sqftResourceState.resourceControllerCounter,
});

const mapDispatchToProps = {
  setFeaturePicker
};


export default connect(mapStateToProps, mapDispatchToProps)(Hinges);
